import { axios } from "../axios.instance";

export type UpdateCardRequest = {
  requestId: string;
  paymentToken: string;
};

export type UpdateCardResponse = object;

export const updateCard = async (body: UpdateCardRequest): Promise<UpdateCardResponse> => {
  const { data } = await axios.patch(`/payments/nmi/update-card`, body);

  return data;
};
